import { Link } from 'react-router-dom';
import { getRedirectUrlOutOfOAuthUrl, getResetUrl } from '../lib/helpers';

export default function FormExtra() {
  // grab the redirect url out of the path to tack onto the reset
  const redirectUri = getRedirectUrlOutOfOAuthUrl();

  const resetUrl = getResetUrl();

  const resetPasswordUrl = resetUrl
    ? resetUrl
    : `/reset/password${redirectUri ? `?redirectUrl=${redirectUri}` : ''}`;
  return (
    <div className="flex items-center justify-between ">
      <div className="text-sm">
        <Link
          to={resetPasswordUrl}
          className="font-medium text-zinc-500 hover:text-gray-600 underline"
        >
          Forgot your password?
        </Link>
      </div>
    </div>
  );
}
